import { useContext } from 'react';
import {
  TransferAssetFlowContext,
  TransferAssetFlowContextValue,
} from '@providers/TransferAssetFlowProvider';

function useTransferAssetFlowContext(): TransferAssetFlowContextValue {
  return useContext(TransferAssetFlowContext);
}

export default useTransferAssetFlowContext;
